import { all } from 'redux-saga/effects';
import betsSaga from './bets';
import bookiesSaga from './bookies';
import { earningsSaga } from './dashboard';
import loginSaga from './login/index';
import marketsSaga from './markets';
import matchesSaga from './matches';
import meSaga from './me';
import paymentsSaga from './payments/index';
import { premiumInfoSaga, publicPremiumInfoSaga } from './premium';
import { taxesInfoSaga } from './pricing';
import sportsSaga from './sports';
import { tipsInfoSaga } from './tips';
import tipsterSaga from './tipster';
import worldCupMatchesSaga from './worldCupMatches';
import worldCupRankingsSaga from './worldCupRankings';
import competitionsSaga from './competitions';
import tipsterPreferencesSaga from './tipsterPreferences';
import settingsSaga from './settings';
import channelsSaga from './channels';

export function* rootSaga() {
  yield all([
    loginSaga(),
    tipsterSaga(),
    betsSaga(),
    matchesSaga(),
    paymentsSaga(),
    meSaga(),
    marketsSaga(),
    bookiesSaga(),
    sportsSaga(),
    premiumInfoSaga(),
    publicPremiumInfoSaga(),
    tipsInfoSaga(),
    earningsSaga(),
    taxesInfoSaga(),
    worldCupMatchesSaga(),
    worldCupRankingsSaga(),
    competitionsSaga(),
    tipsterPreferencesSaga(),
    settingsSaga(),
    channelsSaga(),
  ]);
}
